"use client";

import React from "react";
import styles from './ProgramBanner.module.scss';
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from '@/types/modal';
import { pushToDataLayer } from '@/helpers/gtag';
import { getGlobalStateValue, updateStateSession } from '@/context/utils';
import UnivoImage from "@/components/common/UnivoImage";
import { IMAGE_ASSETS } from "@/constants/images";

const ProgramBanner = ({ associatedPrograms, isAffiliatePage = false }) => {
  const modalDispatch = useModalDispatch();

  const handleBtnClicked = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalV2,
        modalData: {
          heading: "Get Expert Help Choosing the Right Program",
          submitBtnText: "Talk to a Career Expert",
          isLandingPage: true,
          isAffiliatePage,
          associatedPrograms,
          rfiCase: "REDIRECT_APPLICATION_JOURNEY"
        },
      },
    })

    setTimeout(() => {
      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Find Your Program",
        section_name: "middle_banner",
        page_type: getGlobalStateValue("pageType"),
        page_url: window.location.href,
      });

      updateStateSession({
        parentSection: "middle_banner",
        leadStartingCta: "Find Your Program",
      });

      window?.webengage?.track("Find Your Program Clicked", {
        "Page Type": getGlobalStateValue("pageType"),
      });
    }, 2000);
  }

  return (
    <section className={styles.wrapper}>
      <div className={styles.banner}  >
        <div className={styles.leftContent}>
          <h2 className={styles.title}>
            Not sure which program is right for you? Let us help you.
          </h2>
          <p className={styles.description}>
            Explore programs aligned with your interests, career goals, and industry demand.
          </p>
          <button className={styles.ctaButton} onClick={handleBtnClicked}>Find Your Program</button>
        </div>

        <div className={styles.visualSide} >

          <UnivoImage
            className={styles.imgBlob}
            src={IMAGE_ASSETS.programBannerBlob}
            alt="Amity blob"
            width={420}
            height={420}
            sizes="(max-width: 768px) 60vw, 420px"
            loading="lazy"
            fetchPriority="low"
          />
          <UnivoImage
            src={IMAGE_ASSETS.programBannerGlow}
            alt="Background Glow"
            className={styles.imgBanner}
            width={520}
            height={420}
            sizes="(max-width: 768px) 70vw, 520px"
            loading="lazy"
            fetchPriority="low"
          />
        </div>
      </div>
    </section>
  );
};

export default ProgramBanner;